import { EDI_RFID_AUDIT_DELETE_REQUEST, EDI_RFID_AUDIT_DELETE_SUCCESS, EDI_RFID_AUDIT_DELETE_FAILURE } from './types/EdiRfidAuditDeleteActionsTypes';

export function deleteEdiRfidAuditRequestActionCreator(selectedIds) {
  return {
    type: EDI_RFID_AUDIT_DELETE_REQUEST,
    payload: {
      params: {
        requestIds: selectedIds,
      },
    },
  };
}

export function deleteEdiRfidAuditSuccessActionCreator(data) {
  return {
    type: EDI_RFID_AUDIT_DELETE_SUCCESS,
    payload: data,
  };
}

export function deleteEdiRfidAuditFailureActionCreator(error) {
  return {
    type: EDI_RFID_AUDIT_DELETE_FAILURE,
    payload: error,
    error: true,
  };
}
